import React, { Fragment, useEffect, useState } from 'react'
import config from '../../config'
import { Col, Row } from 'react-bootstrap'
import { Card, CardMedia, CardText } from 'material-ui/Card'
import ChatbotDemo from '../chatbot-demo'
import TextField from 'material-ui/TextField'
import StepWizard from 'react-step-wizard'
import {
  EmailShareButton,
  FacebookShareButton,
  LinkedinShareButton,
  TwitterShareButton,
  ViberShareButton,
  WhatsappShareButton,
  WorkplaceShareButton,
} from 'react-share'

import {
  EmailIcon,
  FacebookIcon,
  FacebookMessengerIcon,
  HatenaIcon,
  InstapaperIcon,
  LineIcon,
  LinkedinIcon,
  LivejournalIcon,
  MailruIcon,
  OKIcon,
  PinterestIcon,
  PocketIcon,
  RedditIcon,
  TelegramIcon,
  TumblrIcon,
  TwitterIcon,
  ViberIcon,
  VKIcon,
  WeiboIcon,
  WhatsappIcon,
  WorkplaceIcon,
} from 'react-share'
import _ from 'lodash'
import './bot-preview.css'

export default function(props) {
  const [selectedBot, setSelectedBot] = useState({})

  const [wizardState, updateWizardState] = useState({
    form: {},
  })

  const setInstance = (SW) =>
    updateWizardState({
      ...wizardState,
      SW,
    })

  const drawSelectedInfo = (wizardState, selectedBot) => {
    let { title, description, image } = selectedBot.template_info
    const { SW } = wizardState
    image = `${config.api.host}/api/v1/files/bot/template/image/${image}`

    return (
      <Fragment>
        <div className="selected-template-info">
          <img src={image} className="selected-template-img" alt="" />
          <span className="selected-template-title">{title}</span>
          <span className="selected-template-desc">{description}</span>
          <span className="selected-template-wyg">You Get</span>
          <ul className="checkmark">
            <li>Candidate Contact Info</li>
            <li>Pre-screen Responses</li>
            <li>New Candidate Profile emailed to your hiring team</li>
          </ul>
          <span className="selected-template-back" onClick={SW.previousStep}>
            &larr; Choose Another
          </span>
        </div>
      </Fragment>
    )
  }

  const drawCard = (
    title,
    description,
    image,
    id,
    selectedTemplate,
    onTapCard,
    state,
    bot,
  ) => {
    const active = selectedTemplate === id

    const { SW } = state

    return (
      <Col xs={6}>
        <div
          onClick={() => {
            if (bot) {
              setSelectedBot(bot)
              props.autobotProps.handleOnSelectTemplate(bot.id)
            }
          }}
        >
          <div
            className={`template-card-2 ${
              active ? 'template-card-2-active' : 'template-card-2-inactive'
            }`}
          >
            <div className="template-card-2-img-container">
              <img src={image} className="template-card-2-img" alt="" />
            </div>
            <div className="template-card-2-description-container">
              <span className="template-title">{title}</span>
              <span className="template-desc">{description}</span>
            </div>
          </div>
        </div>
      </Col>
    )
  }

  const templates = props.autobotProps.botTemplates.map((bot) => {
    return drawCard(
      bot.template_info.title,
      bot.template_info.description,
      `${config.api.host}/api/v1/files/bot/template/image/${bot.template_info.image}`,
      bot.id,
      selectedBot.id,
      () => {
        //do nothing
      },
      wizardState,
      bot,
    )
  })

  const Nav = (props) => {
    const dots = []
    for (let i = 1; i <= props.totalSteps; i += 1) {
      let label = 'Step 1'

      switch (i) {
        case 1:
          label = 'Step 1'
          break
        case 2:
          label = 'Step 2'
          break
        case 3:
          label = 'Step 3'
          break
      }

      const isActive = props.currentStep === i
      dots.push(
        <span
          key={`step-${i}`}
          className={`${isActive ? 'store-step-active' : 'store-step'}`}
          onClick={() => props.goToStep(i)}
        >
          {label}
        </span>,
      )
    }

    return (
      <Row>
        <Col xs={12} className="navwizard-nav-container">
          {dots}
        </Col>
      </Row>
    )
  }

  const { SW } = wizardState

  return (
    <Fragment>
      <Row>
        <Col xs={12} md={12}>
          <Fragment>
            <Row>
              <Col xs={12} md={8} style={{ paddingLeft: '10px' }}>
                <StepWizard
                  // nav={<Nav />}
                  className="stepwizard-nav"
                  instance={setInstance}
                >
                  {/** step 1 */}
                  <Fragment>
                    <Row>
                      {/**chose a script */}
                      <Col xs={12} md={8}>
                        <Row>
                          <Col xs={12} className="step-wizard-section-header">
                            <div
                              style={{
                                display: 'flex',
                                flexDirection: 'row',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                              }}
                            >
                              <div className="step-circle-container no-height">
                                <span className="step-circle step-circle-active">
                                  1
                                </span>
                              </div>
                              <h3>Choose a Script</h3>
                            </div>

                            <p>
                              Choose a base template for your Apply-by-Text
                              Solution
                            </p>
                          </Col>
                        </Row>
                        <Row>
                          <Col xs={12}>
                            <Row>{templates}</Row>
                          </Col>
                        </Row>
                      </Col>
                      {/**customize mesage */}
                      <Col xs={12} md={4}>
                        <Row>
                          <Col xs={12}>
                            <Row>
                              <Col
                                xs={12}
                                className="step-wizard-section-header left"
                              >
                                <div
                                  style={{
                                    display: 'flex',
                                    flexDirection: 'row',
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                  }}
                                >
                                  <div className="step-circle-container no-height">
                                    <span className="step-circle step-circle-active">
                                      2
                                    </span>
                                  </div>
                                  <h3>Customize Messages</h3>
                                </div>

                                <p>
                                  Type in your information to personalize
                                  messages
                                </p>
                              </Col>
                            </Row>

                            <Row>
                              <Col xs={12}>
                                <TextField
                                  floatingLabelFixed={true}
                                  floatingLabelText="What's your company name?"
                                  fullWidth={true}
                                  multiLine={false}
                                  value={props.autobotProps.brandName}
                                  onChange={props.autobotProps.handleOnChange(
                                    'brandName',
                                  )}
                                  floatingLabelStyle={{
                                    color: '#39B54A',
                                    fontSize: '1.3em',
                                    top: '27px',
                                  }}
                                />
                              </Col>
                            </Row>

                            <Row style={{ marginTop: '10px' }}>
                              <Col xs={12}>
                                <TextField
                                  floatingLabelFixed={true}
                                  floatingLabelText="What's your website?"
                                  fullWidth={true}
                                  multiLine={false}
                                  value={props.autobotProps.careerSiteUrl}
                                  onChange={props.autobotProps.handleOnChange(
                                    'careerSiteUrl',
                                  )}
                                  floatingLabelStyle={{
                                    color: '#39B54A',
                                    fontSize: '1.3em',
                                    top: '27px',
                                  }}
                                />
                              </Col>
                            </Row>
                          </Col>
                        </Row>
                        <Row style={{ marginTop: '50px' }}>
                          <Col xs={12} style={{ textAlign: 'center' }}>
                            <div
                              style={{
                                display: 'flex',
                                flexDirection: 'row',
                                justifyContent: 'center',
                                alignItems: 'center',
                              }}
                            >
                              <button
                                style={{ margin: '0px 10px' }}
                                onClick={() => {
                                  if (!selectedBot.id) {
                                    setSelectedBot(
                                      _.first(props.autobotProps.botTemplates),
                                    )
                                  }
                                  props.autobotProps.handleOnSelectTemplate(
                                    (selectedBot.id
                                      ? selectedBot
                                      : _.first(props.autobotProps.botTemplates)
                                    ).id,
                                  )

                                  // SW.nextStep()
                                }}
                                className="store-btn store-btn-preview"
                              >
                                Preview &rarr;
                              </button>
                            </div>
                          </Col>
                        </Row>

                        <Row className="call-to-action-container">
                          <Col xs={12} style={{ textAlign: 'center' }}>
                            <div
                              style={{
                                display: 'flex',
                                flexDirection: 'row',
                                justifyContent: 'center',
                                alignItems: 'center',
                              }}
                            >
                              <button
                                style={{ margin: '0px 10px' }}
                                onClick={() => {
                                  if (!selectedBot.id) {
                                    setSelectedBot(
                                      _.first(props.autobotProps.botTemplates),
                                    )
                                  }
                                  props.autobotProps.handleOnSelectTemplate(
                                    (selectedBot.id
                                      ? selectedBot
                                      : _.first(props.autobotProps.botTemplates)
                                    ).id,
                                  )
                                  SW.nextStep()
                                }}
                                className="store-btn store-btn-hero store-btn-preview"
                              >
                                Buy Now
                              </button>
                            </div>
                            <div style={{ marginTop: '10px' }}>
                              <strong><em>Lets get started!</em></strong>
                            </div>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </Fragment>
                  {/**Step 2 */}

                  <Fragment>
                    <Col xs={12} mdOffset={2} md={10}>
                      <span
                        className="selected-template-back"
                        onClick={() => {
                          SW.previousStep()
                        }}
                      >
                        &larr; Customize
                      </span>
                      <div className="preview-step-content">
                        <span className="preview-step-content-header">
                          Here's a preview of <br />{' '}
                          {props.autobotProps.brandName}
                          's <span className="abt-text-em">
                            Apply-by-Text
                          </span>{' '}
                          Solution.
                        </span>
                        <span className="preview-step-content-engage">
                          <strong>Aquire</strong> ,<strong>Engage</strong>, and{' '}
                          <strong>Hire</strong> Faster!
                        </span>
                        <span className="preview-step-content-get">
                          Through Apply-by-Text, you get :
                        </span>
                        <div style={{ textAlign: 'left' }}>
                          <ul className="checkmark">
                            <li>Candidate Contact Info</li>
                            <li>Pre-screen Responses</li>
                            <li>
                              New Candidate Profile emailed to your hiring team
                            </li>
                          </ul>
                        </div>
                        <span className="preview-step-content-share-text">
                          Save and share this to your colleagues!
                        </span>
                        <div className="preview-step-content-share">
                          <EmailShareButton url="https://gohire.com">
                            <EmailIcon size={48} round={true} />
                          </EmailShareButton>
                          <LinkedinShareButton url="https://gohire.com">
                            <LinkedinIcon size={48} round={true} />
                          </LinkedinShareButton>
                          <FacebookShareButton url="https://gohire.com">
                            <FacebookIcon size={48} round={true} />
                          </FacebookShareButton>
                          <TwitterShareButton url="https://gohire.com">
                            <TwitterIcon size={48} round={true} />
                          </TwitterShareButton>
                        </div>
                      </div>
                      <Row>
                        <Col xs={12} style={{ textAlign: 'center' }}>
                          <a
                            onClick={() => SW.nextStep()}
                            class="buy-btn"
                          >
                            <span class="elButtonMain">Buy Now!</span>
                            <span class="elButtonSub"></span>
                          </a>
                        </Col>
                      </Row>
                    </Col>
                  </Fragment>

                   {/**Step 3 */}

                   <Fragment>
                    <Col xs={12} mdOffset={2} md={10}>
                      <span
                        className="selected-template-back"
                        onClick={() => {
                          SW.previousStep()
                        }}
                      >
                        &larr; Share
                      </span>
                      <div className="preview-step-content">
                        <span className="preview-step-content-header">
                          {props.autobotProps.brandName}
                          's <span className="abt-text-em">
                            Apply-by-Text
                          </span>{' '}
                          Solution.
                        </span>
                        <span className="preview-step-content-engage">
                          <strong>Aquire</strong> ,<strong>Engage</strong>, and{' '}
                          <strong>Hire</strong> Faster!
                        </span>
                        <div className="preview-step-content-get">
                        <Row>
                              <Col xs={6} xsOffset={3}>
                                <TextField
                                  floatingLabelFixed={true}
                                  floatingLabelText="What's your name?"
                                  fullWidth={true}
                                  multiLine={false}
                                  value={props.autobotProps.name}
                                  onChange={props.autobotProps.handleOnChange(
                                    'name',
                                  )}
                                  floatingLabelStyle={{
                                    color: '#39B54A',
                                    fontSize: '1.3em',
                                    top: '27px',
                                  }}
                                />
                              </Col>
                            </Row>
                            <Row>
                              <Col xs={6} xsOffset={3}>
                                <TextField
                                  floatingLabelFixed={true}
                                  floatingLabelText="What's your email?"
                                  fullWidth={true}
                                  multiLine={false}
                                  value={props.autobotProps.email}
                                  onChange={props.autobotProps.handleOnChange(
                                    'email',
                                  )}
                                  floatingLabelStyle={{
                                    color: '#39B54A',
                                    fontSize: '1.3em',
                                    top: '27px',
                                  }}
                                />
                              </Col>
                            </Row>
                        </div>
                        
                      </div>
                      <Row>
                        <Col xs={12} style={{ textAlign: 'center' }}>
                          <a
                            onClick={() => props.autobotProps.handleOnBuy()}
                            class="buy-btn"
                          >
                            <span class="elButtonMain">Proceed to Payment</span>
                            <span class="elButtonSub"></span>
                          </a>
                        </Col>
                      </Row>
                    </Col>
                  </Fragment>
                </StepWizard>
              </Col>

              {/**preview bot */}
              <Col
                xs={12}
                md={4}
                style={{
                  textAlign: 'center',
                  height: '780px',
                }}
              >
                <div
                  style={{
                    display: 'flex',
                    width: '100%',
                    justifyContent: 'center',
                    alignContent: 'center',
                  }}
                >
                  <ChatbotDemo script={props.autobotProps.script} />
                </div>
              </Col>
            </Row>
          </Fragment>
        </Col>
      </Row>
    </Fragment>
  )
}
